// First, let's create proper interfaces for the data
interface GeneralStepData {
  general: {
    outlet_legal_name?: string;
    outlet_trade_name?: string;
    outlet_group_name?: string;
    billing_outlet_address?: string;
    billing_country?: string;
    billing_city?: string;
    billing_phone?: string;
    billing_po_box?: string;
    delivery_outlet_address?: string;
    delivery_country?: string;
    delivery_city?: string;
    delivery_phone?: string;
    delivery_po_box?: string;
    service_years?: string;
    website_url?: string;
  };
  license: {
    license_number?: string;
    license_expiration?: Date;
  };
}

interface Contact {
  name?: string;
  position?: string;
  phone?: string | number;
  email?: string;
}

interface Signature {
  name?: string;
  position?: string;
}

interface Requests {
  credit_limit?: number;
  credit_period?: string | number;
}

export const validateGeneralStep = (data: GeneralStepData): boolean => {
  if (!data.general || !data.license) return false;
  
  const requiredGeneralFields = [
    'outlet_legal_name',
    'outlet_trade_name',
    'outlet_group_name',
    'billing_outlet_address',
    'billing_country',
    'billing_city',
    'billing_phone',
    'billing_po_box',
    'delivery_outlet_address',
    'delivery_country',
    'delivery_city',
    'delivery_phone',
    'delivery_po_box',
    'service_years',
    'website_url'
  ];

  const hasAllGeneralFields = requiredGeneralFields.every(
    field => data.general[field as keyof typeof data.general]?.toString().trim() !== ''
  );

  const hasAllLicenseFields = data.license.license_number?.trim() !== '' 
    && data.license.license_expiration !== undefined;

  return hasAllGeneralFields && hasAllLicenseFields;
};

export const validateContactsStep = (data: { contacts: Contact[] }): boolean => {
  if (!data.contacts || !Array.isArray(data.contacts)) return false;
  
  return data.contacts.length > 0 && data.contacts.every(contact => 
    contact.name?.toString().trim() !== '' &&
    contact.position?.toString().trim() !== '' &&
    contact.phone?.toString().trim() !== '' &&
    contact.email?.toString().trim() !== ''
  );
};

export const validateUploadsStep = (data: {
  signatures?: Signature[];
  requests?: Requests;
}): boolean => {
  if (!data.signatures || !data.requests) return false;

  const hasValidSignatures = Array.isArray(data.signatures) && 
    data.signatures.length > 0 &&
    data.signatures.every(sig => 
      sig.name?.toString().trim() !== '' && 
      sig.position?.toString().trim() !== ''
    );

  const hasValidRequests = 
    data.requests.credit_limit !== undefined &&
    data.requests.credit_limit > 0 &&
    data.requests.credit_period !== undefined &&
    data.requests.credit_period.toString().trim() !== '';

  return hasValidSignatures && hasValidRequests;
};
